'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import config from '../../js/config';
import PromotionalGiveawayModal from './PromotionalGiveawayModal';
import PromotionalGiveawayEngineeringQuestionTemplate from './templates/_PromotionalGiveawayEngineeringQuestion.hbs';
import cookies from 'js-cookie';

export default class PromotionalGiveawayEngineeringQuizView extends Backbone.View {
  constructor($el) {
    super($el);
  }
  get events() {
    return {
      'change input[type=radio]': 'changedRadio',
      'click .PromotionalGiveaway-EngineerQuiz-next': 'getNextQuestion',
      'click .PromotionalGiveaway-EngineerQuiz-previous': 'getPreviousQuestion'
    }
  }
  initialize() {
    this.requestEngineeringQuizData(this.$el.find('.questions').data('engineeringQuizItem')).done(quizResponse => {
      this.engineerQuizData = quizResponse;
      this.startingTime = Date.now();
      this.model = {};
      if (this.engineerQuizData) {
        this.model.headerText = this.engineerQuizData.QuizBanner;
        this.model.headerDescription = this.engineerQuizData.QuizDescription;
        this.model.currentQuestion = this.engineerQuizData.QuizQuestionsJson[0];
        this.model.currentIndex = 0;
        this.model.currentQuestionNumber = this.model.currentIndex + 1;
        this.model.questionsLength = this.engineerQuizData.QuizQuestionsJson.length;
        this.model.nextText = this.engineerQuizData.QuizNavigationNextCtaValue;
        this.model.previousText = this.engineerQuizData.QuizNavigationPreviousCtaValue;
        this.model.quizQuestionIndexText = this.engineerQuizData.QuizQuestionIndexText;
        this.model.quizQuestionUnAnsweredErrorMsg = this.engineerQuizData.QuizQuestionUnAnsweredErrorMsg;
        this.renderEngineeringQuiz();
      }
    });
  }

  changedRadio(event) {
    this.$el.find('.validation').addClass('PromotionalGiveaway-EngineerQuiz-is-hidden');
    this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex].answer = event.target.value;
  }

  getNextQuestion() {
    if (this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex].answer) {
      this.model.currentIndex++;
      this.model.currentQuestionNumber++;
      if (this.model.currentIndex === this.engineerQuizData.QuizQuestionsJson.length) {
        this.submitEngineerQuiz();
      }
      else {
        if (this.model.currentIndex === this.engineerQuizData.QuizQuestionsJson.length - 1) {
          this.model.nextText = this.engineerQuizData.QuizNavigationSubmitCtaValue;
        }
        this.model.currentQuestion = this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex];
        this.renderEngineeringQuiz();
        this.$el.find(':radio[value=' + this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex].answer + ']').prop('checked', true);
      }
    }
    else {
      this.$el.find('.PromotionalGiveaway-EngineerQuiz-validation').removeClass('PromotionalGiveaway-EngineerQuiz-is-hidden');
    }
  }
  /**
   * This method will be triggered when user clicks on previous button
   */
  getPreviousQuestion() {
    this.model.currentIndex--;
    this.model.currentQuestionNumber--;
    this.model.currentQuestion = this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex];
    if (this.model.currentIndex !== this.engineerQuizData.QuizQuestionsJson.length) {
      this.model.nextText = this.engineerQuizData.QuizNavigationNextCtaValue;
    }
    this.renderEngineeringQuiz();
    this.$el.find(':radio[value=' + this.engineerQuizData.QuizQuestionsJson[this.model.currentIndex].answer + ']').prop('checked', true);
  }

  renderEngineeringQuiz() {
    this.$el.find('.question').html(PromotionalGiveawayEngineeringQuestionTemplate(this.model));
    this.$engineerQuizPrevious = this.$el.find('.PromotionalGiveaway-EngineerQuiz-previous');
    if (this.model.currentIndex) {
      this.$engineerQuizPrevious.removeClass('PromotionalGiveaway-EngineerQuiz-is-hidden');
    }
  }

  submitEngineerQuiz() {
    let engineerQuizData = {
      triviaLandingItemId: this.engineerQuizData.TriviaLandingItemId,
      userPromoRegestrationGuid: cookies.get('PromotionalGiveawayGUID'),
      isVideoTrivia: false,
      isEngineeringQuiz: true,
      triviaActionType: this.engineerQuizData.TriviaActionType,
      triviaUserResponseList: this.formatEngineerQuiz(),
      completionTime: this.timeCompleted(Date.now())
    }
    this.postAnswers(JSON.stringify(engineerQuizData));

  }

  timeCompleted(finishTime) {
    let timeCompleted = finishTime - this.startingTime;
    let minutes = Math.floor(timeCompleted / 60000);
    let seconds = ((timeCompleted % 60000) / 1000).toFixed(0);
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  formatEngineerQuiz() {
    let answerList = [];
    for (var index = 0; index < this.engineerQuizData.QuizQuestionsJson.length; index++) {
      let answerObject = {};
      answerObject.questionItemId = this.engineerQuizData.QuizQuestionsJson[index].QuestionCmsId;
      answerObject.userAnswerChoice = this.engineerQuizData.QuizQuestionsJson[index].answer;
      answerList.push(answerObject);
    }
    return answerList;
  }

  postAnswers(triviaData) {
    $.ajax(config.promoGiveaway.videoTriviaPostUrl, {
      contentType: 'application/json',
      method: 'POST',
      data: triviaData
    })
      .done(triviaResponse => {
        this.onSubmitSuccess(triviaResponse);
      })
      .fail(() => { this.onSubmitFailed(); });
  }

  requestEngineeringQuizData(guid) {
    let url = config.promoGiveaway.getEngineeringQuizDataUrl + guid;
    return $.ajax({
      contentType: 'application/json',
      method: 'POST',
      url
    });
  }

  onSubmitSuccess(triviaResponse) {
    let modal = new PromotionalGiveawayModal();
    if (this.engineerQuizData) {
      modal.open({
        title: this.engineerQuizData.ActionCompleteTitleText,
        message: (triviaResponse && triviaResponse.engineeringQuizResult) ?
          triviaResponse.engineeringQuizResult : this.engineerQuizData.ActionCompleteDescription,
        cta1Link: this.engineerQuizData.ReturntoCta1Url,
        cta1Text: this.engineerQuizData.ReturntoCta1Text,
        cta2Link: this.engineerQuizData.ReturnToCta2Url,
        cta2Text: this.engineerQuizData.ReturnToCta2Text
      });
    }
  }
  onSubmitFailed() {
    let modal = new PromotionalGiveawayModal();
    modal.open({
      title: this.engineerQuizData.ActionPostFailTitleText,
      message: this.engineerQuizData.ActionPostFailMessage
    });
  }
}



// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveawayEngineeringQuiz.js